package com.starparty.app.astro0.celestialobjects

import com.starparty.app.astro0.*
import com.starparty.app.geometry.SP_Point
import com.starparty.app.vector_maths.Matrix4d
import com.starparty.app.vector_maths.Point2d
import com.starparty.app.vector_maths.Point3d
import kotlin.math.sqrt

/**
 * Title:
 * Description:
 * Copyright:    Copyright (c) 2002
 * Company:
 * @author
 * @version 1.0
 */
open class CelestialPoint: Searchable {
    var name: String = ""
    var cartesianCoordinates = Point3d()
        protected set
    var skyLocation = Point3d()
        protected set
    var itsRA_Radians = 0.0
    var itsDec_Radians = 0.0

    constructor() {}
    constructor(raDegrees: Double, decDegrees: Double) {
        itsRA_Radians = raDegrees * MathD.DEG_TO_RAD
        itsDec_Radians = decDegrees * MathD.DEG_TO_RAD
        calculateCartesianCoordinates()
    }

    protected open fun calculateCartesianCoordinates() {
        val equ = equatorialCoords
        SphericalCoords.sphericalToCartesian(equ.rA, equ.dec, cartesianCoordinates)
    }

    val equatorialCoords: SphPoint
        get() = SphPoint(itsRA_Radians, itsDec_Radians)

    /** Uses the transform matrix to calculate and set the
     * pixel location at which the body will be
     * drawn when 'paint(Graphics)' is called.  */
    fun setSkyLocation(m: Matrix4d) {
        calculateCartesianCoordinates()
        val c = cartesianCoordinates
        val p = Projection.projectFromMatrix(c, m)
        val x = p.x
        val y = p.y
        skyLocation.x = x
        skyLocation.y = y
    }

    fun getRA_HMSString(decimalPlaces: Int): String {
        val raDegrees = itsRA_Radians * MathD.DEG_TO_RAD
        return UMS.degreesToHMS(raDegrees).toString(decimalPlaces, "h", "m", "s")
    }

    fun getDec_DMSString(decimalPlaces: Int): String {
        val decDegrees = itsDec_Radians * MathD.DEG_TO_RAD
        return UMS.degreesToDMS(decDegrees).toString(decimalPlaces, "d", "\'", "\"")
    }

    override fun getSearchableName(): String {
        return name
    }

    override fun getEquatorialCoordinates(): SphPoint {
        return equatorialCoords
    }

    override fun getSearchableObjectType(): String {
        return ""
    }
}